<div class="modal-header">
    <h2 class="modal-title"> Change configuration</h2>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.close('CLOSE')"
    ></button>
</div>
<div class="modal-body">
    <h4 class="modal-subtitle">
        Select the component to be changed in {{ selectedEntities | countEntityTypes }}
    </h4>
    <ama-ng-configurations-accordion
            [cmpsWithConfigs]="cmpsWithConfigs"
            [entitySelected]="entitySelected"
            [(selectedConfigurations)]="selectedConfigurations"
            [redefinedConfigSuccess]="redefinedConfigSuccess"
            [editConfiguration]="editConfiguration"
            [displayDynamicForm]="displayDynamicForm">
    </ama-ng-configurations-accordion>
</div>
<div class="modal-footer flex-row gap-2">
    @if (containsPotentialConfigurationOverrides && containsPotentialConfigurationOverrides !== SizeOverlap.NONE) {
        <ngb-alert dfInsertAlertIcon [dismissible]="false">
            <strong>Warning!</strong>
            One or more entities will override their configuration
        </ngb-alert>
    }
    <div class="flex-grow-1 spacer"></div>
    <button id="cancel-btn-config-modal"
            type="button"
            class="btn btn-outline-primary me-5"
            aria-label="Close"
            (click)="activeModal.close('CANCEL')">Cancel
    </button>
    <button id="save-btn-config-modal"
            type="button"
            class="btn btn-primary"
            [disabled]="!(selectedConfigurations | hasConfigurationsChanged: selectedEntities)"
            (click)="save()">
        Save changes
    </button>
</div>
